<script>
import interact from "interactjs";
import emailjs from "emailjs-com";
export default {
  props: {
    windowId: String,
    nameOfWindow: String,
    content_padding_left: {
      required: false,
      type: String,
      default: "15%",
    },
    content_padding_right: {
      required: false,
      type: String,
      default: "15%",
    },
    content_padding_top: {
      required: false,
      type: String,
      default: "5%",
    },
    content_padding_bottom: {
      required: false,
      type: String,
      default: "5%",
    },
  },
  data: function () {
    return {
      ComponentName: this.nameOfWindow,
      Window: {},
      dragOption: {
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: "#screen",
            endOnly: true,
          }),
        ],
        allowFrom: "#top-bar",
      },
      x: 0,
      y: 0,
      tempX: 0,
      tempY: 0,
      w: 400,
      h: 400,
      mailSubject: "",
      mailSender: "",
      mailContent: "",
    };
  },
  computed: {
    style() {
      return {
        height: `${this.h}px`,
        width: `${this.w}px`,
        transform: `translate(${this.x}px, ${this.y}px)`,
        "--content-padding-left": this.content_padding_left || "15%",
        "--content-padding-right": this.content_padding_right || "15%",
        "--content-padding-top": this.content_padding_top || "5%",
        "--content-padding-bottom": this.content_padding_bottom || "5%",
        "--fullscreen": this.$store.getters.getFullscreenWindowHeight,
      };
    },
  },
  created() {
    this.window = this.$store.getters.getWindowById(this.ComponentName);
  },
  methods: {
    closeWindow() {
      const payload = {
        windowState: "close",
        windowID: this.ComponentName,
      };
      this.$store.commit("setWindowState", payload);
    },

    openWindow() {
      const payload = {
        windowState: "open",
        windowID: this.ComponentName,
      };
      this.$store.commit("setWindowState", payload);
    },

    minimizeWindow() {
      const payload = {
        windowState: "minimize",
        windowID: this.ComponentName,
      };
      this.$store.commit("setWindowState", payload);
    },

    toggleWindowSize() {
      if (this.$store.getters.getWindowFullscreen(this.ComponentName) == true) {
        const payload = {
          fullscreen: false,
          windowID: this.ComponentName,
        };
        this.$store.commit("setFullscreen", payload);
        this.x = this.tempX;
        this.y = this.tempY;
      } else if (
        this.$store.getters.getWindowFullscreen(this.ComponentName) == false
      ) {
        const payload = {
          fullscreen: true,
          windowID: this.ComponentName,
        };
        this.$store.commit("setFullscreen", payload);
        const tempX = this.x;
        const tempY = this.y;
        this.tempX = tempX;
        this.tempY = tempY;
        this.x = 0;
        this.y = 0;
      }
    },

    setActiveWindow() {
      this.$store.commit("zIndexIncrement", this.ComponentName);
      this.$store.commit("setActiveWindow", this.ComponentName);
    },

    dragmove(event) {
      this.x += event.dx;
      this.y += event.dy;
      this.setActiveWindow();
    },

    resizemove(event) {
      this.w = event.rect.width;
      this.h = event.rect.height;

      this.x += event.deltaRect.left;
      this.y += event.deltaRect.top;
    },

    async sendEmail(e) {
      e.preventDefault();

      emailjs
        .sendForm(
          "service_xotv396",
          "template_sa8gcva",
          e.target,
          "cE3jg5-r0Xmx5Jhfb"
        )
        .then(
          () => {
            this.closeWindow();
            this.$store.commit("updateMailSender", "");
            this.$store.commit("updateMailSubject", "Nova mensagem");
            this.$store.commit("updateMailContent", "");
            alert("E-mail enviado com sucesso!");
          },
          (error) => {
            console.log(error.text);
            alert("Ocorreu um erro ao enviar o e-mail!");
          }
        );
    },

    checkMail() {
      if (this.$store.getters.mailSubject == "Nova mensagem") {
        return "";
      } else {
        return this.$store.getters.mailSubject;
      }
    },
    onChangeMailSubject() {
      if (this.mailSubject.replace(/\s/g, "") == "") {
        this.$store.commit("updateMailSubject", "Nova mensagem");
      } else {
        this.$store.commit("updateMailSubject", this.mailSubject);
      }
    },
    onChangeMailSender() {
      if (this.mailSender.replace(/\s/g, "") == "") {
        this.$store.commit("updateMailSender", "");
      } else {
        this.$store.commit("updateMailSender", this.mailSender);
      }
    },
    onChangeMailContent() {
      if (this.mailContent.replace(/\s/g, "") == "") {
        this.$store.commit("updateMailContent", "");
      } else {
        this.$store.commit("updateMailContent", this.mailContent);
      }
    },
  },
};
</script>

<template>
  <interact
    draggable
    :dragOption="dragOption"
    resizable
    class="window window-style"
    :style="style"
    @dragmove="dragmove"
    @resizemove="resizemove"
    @click.native="setActiveWindow"
    :class="{
      fullscreen: $store.getters.getWindowFullscreen(this.ComponentName),
      minimize:
        $store.getters.getWindowById(ComponentName).windowState == 'minimize',
    }"
  >
    <iframe
      name="hidden_iframe"
      id="hidden_iframe"
      style="display: none"
      onload="if(this.submitted)  {window.location='';}"
    ></iframe>
    <form
      v-on:submit="sendEmail"
      action="https://docs.google.com/forms/u/0/d/e/1FAIpQLSdRBqHB0Z6GOjwE3jniX8-fHfJK-WcyzNTmkPFg4fg2SYPwpA/formResponse"
      class="window"
      id="container"
      target="hidden_iframe"
    >
      <div
        class="top-bar-window"
        :class="
          $store.getters.getActiveWindow == this.ComponentName
            ? 'top-bar'
            : 'top-bar-deactivated'
        "
        id="top-bar"
        @dblclick="toggleWindowSize"
      >
        <div class="window-name">
          <img
            class="icon-image"
            :src="require('@/assets/win95/' + this.window.iconImage)"
            :alt="window.altText"
          />{{ this.window.displayName }}
        </div>
        <div class="triple-button">
          <button class="minimize-button button" @click="minimizeWindow">
            <span
              style="
                height: 2px;
                width: 6px;
                background: black;
                margin-top: 8px;
                margin-right: 2px;
              "
            >
            </span>
          </button>
          <button class="expand-button button" @click="toggleWindowSize">
            <span
              style="
                height: 8px;
                width: 9px;
                border-left: black 1px solid;
                border-right: black 1px solid;
                border-left: black 1px solid;
                border-bottom: black 1px solid;
                border-top: black 2px solid;
              "
            >
            </span>
          </button>
          <button
            class="close-button button"
            style="margin-right: 3px; padding-left: 1px"
            @click="closeWindow"
          >
            <svg
              height="512px"
              id="Layer_1"
              style="enable-background: new 0 0 512 512"
              version="1.1"
              viewBox="0 0 512 512"
              width="512px"
            >
              <path
                d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
              />
            </svg>
          </button>
        </div>
      </div>
      <div class="send-bar">
        <button type="submit" class="sent" style="z-index: 10">
          <span class="border">
            <img src="@/assets/win95/send.png" class="icon-image" />
            <p style="margin-top: 2px; color: black">Enviar</p>
          </span>
        </button>
      </div>
      <div class="content">
        <div class="container-details">
          <div class="header">{{ $store.getters.mailSubject }}</div>
          <hr />
          <div class="subject-container">
            <p style="margin: 8px">Para:</p>
            <div class="receipient">Gean</div>
          </div>
          <hr />
          <div class="from-container" style="margin-bottom: 8px">
            <p style="margin: 8px">De:</p>
            <input
              name="name"
              class="subject"
              v-model="mailSender"
              v-on:input="onChangeMailSender"
              type="email"
              required="true"
            />
          </div>
          <hr />
          <div class="subject-container">
            <p style="margin: 8px">Assunto:</p>
            <input
              name="subject"
              class="subject"
              v-model="mailSubject"
              v-on:input="onChangeMailSubject"
              type="text"
              required="true"
            />
          </div>
          <hr />
        </div>

        <textarea
          name="message"
          v-model="mailContent"
          v-on:input="onChangeMailContent"
          required="true"
        ></textarea>
      </div>
    </form>
  </interact>
</template>

<style scoped>
/*-------------------------------------------*\
    Windows/Display
\*-------------------------------------------*/

.minimize {
  display: none;
}

.window {
  box-sizing: border-box;
  padding: 0px;
  margin: 0px;
  user-select: none;
  -ms-touch-action: none;
  touch-action: none;
  flex-flow: column;
  display: flex;
  max-width: 100vw !important;
}

.fullscreen {
  width: 100% !important;
  height: var(--fullscreen) !important;
  margin: 0;
  transition: all 0.5s ease;
  padding: 0;
}

.content {
  flex-direction: column;
  flex-grow: 1;
  height: var(--fullscreen) !important;
  overflow: hidden;
  display: flex;
  overflow-x: hidden;
  padding-right: var(--content-padding-right);
  padding-left: var(--content-padding-left);
  padding-top: var(--content-padding-top);
  padding-bottom: var(--content-padding-bottom);
}

/*-------------------------------------------*\
    Top Bar
\*-------------------------------------------*/

.top-bar {
  background: rgb(0, 0, 124);
}

.icon-image {
  width: 15px;
  height: 15px;
  margin-right: 5px;
  margin-top: 0;
  margin-bottom: 0;
}

.top-bar-window {
  display: flex;
  width: auto;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  z-index: 10;
  margin: 2px;
  padding: 2px 2px 2px 2px;
}

.top-bar-deactivated {
  background: rgb(123, 125, 123);
}

.top-bar:hover {
  cursor: default;
}

.window-name {
  color: white;
  display: flex;
  align-items: center;
  font-weight: 500;
  padding: 0;
  font-size: 16px;
  margin: 0 0 0 3px;
}

.subject {
  width: 100%;
  background: none;
  border: none;
}

p {
  color: rgb(155, 155, 155);
  margin-right: 5px;
  font-size: 14px;
  margin: 0 0 0 0;
  padding: 0 0 0 0;
}

button {
  outline: none;
}

hr {
  background-color: rgb(155, 155, 155, 0.2);
  width: 100%;
}

.sent {
  vertical-align: middle;
  box-shadow: 1.5px 1.5px black;
  border-top: solid rgb(250, 250, 250) 1.5px;
  border-left: solid rgb(250, 250, 250) 1.5px;
  border-bottom: solid rgb(90, 90, 90) 1.5px;
  border-right: solid rgb(90, 90, 90) 1.5px;
  background: rgb(192, 192, 192);
  padding: 1px;
}

.sent:active {
  box-shadow: none;
  background: repeating-conic-gradient(
      rgb(189, 190, 189) 0% 25%,
      rgb(255, 255, 255) 0% 50%
    )
    50% / 2px 2px;
  border-top: solid rgb(0, 0, 0) 1.5px;
  /* border-left: solid rgb(0, 0, 0) 1.5px; */
  border-bottom: solid rgb(250, 250, 250) 1.5px;
  border-right: solid rgb(250, 250, 250) 1.5px;
}

.border {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
}

.border:active {
  border: black dotted 1px;
}

.sent:hover {
  cursor: pointer;
}

.container-details {
  border: 1px white solid;
  background: white;
  width: 100%;
}

.header {
  font-weight: 700;
  font-size: 24px;
  padding-top: 10px;
  margin-left: 8px;
  text-overflow: ellipsis;
  overflow: auto;
  max-width: auto;
}

.send-bar {
  border: 1px white solid;
  outline: 1px rgb(123, 125, 123) solid;
  font-size: 12px;
  padding: 4px;
  margin: 2px;
}

.receipient {
  background: rgb(194, 214, 252);
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 3px;
  font-size: 14px;
}

.subject-container {
  display: flex;
  height: 20px;
  align-items: center;
}

.from-container {
  display: flex;
  height: 20px;
  align-items: center;
}

input {
  outline: none;
}

textarea {
  margin: 0;
  background: #fff;
  border-top: solid rgb(0, 0, 0) 1.5px;
  border-left: solid rgb(0, 0, 0) 1.5px;
  border-bottom: solid rgb(250, 250, 250) 1.5px;
  border-right: solid rgb(0, 0, 0) 1.5px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  resize: none;
  caret-color: black;
  color: black;
  font-size: 16px;
  border-radius: 0;
  flex-grow: 1;
  padding: 4px;
  width: 99% !important;
}
</style>
